import React, { useState, useEffect } from 'react'

import { Trash } from 'lucide-react'
import { Input, Row, Col, ButtonIcon } from 'twyne-new.ui'

import Inputy from 'components/form/Input'

import MergetagInputTip from './MergetagInputTip'
import SelectCreatable from './SelectCreatable'

export default function ParamItem({ data: [key, value], onDelete, onChange, index, name = '_' }) {
  return <Row>
    <Col size='6'>
      <MergetagInputTip id={`pname-${index}`}>
        <Input
          placeholder="name"
          value={key}
          onChange={e => onChange && onChange(e.target.value, value)}
        />
      </MergetagInputTip>
    </Col>
    <Col size='5'>
      <ValueComponent
        index={index}
        promptTextCreator={label => `Create the mergetag "${label}"`}
        name={name}
        clearable={false}
        placeholder="create a mergetag"
        value={value}
        onChange={onChange && onChange.bind(null, key)}
      />
    </Col>
    {!onDelete ? null : <Col size='1' className='flex items-center'>
      <ButtonIcon content='Delete' onClick={() => onDelete()}>
        <Trash size={16} />
      </ButtonIcon>
    </Col>}
  </Row>
}

function ValueComponent({ value, name, onChange, index, ...selectProps }) {
  const [staticValue, setStaticValue] = useState(false)

  const loadValue = value => {
    if (value === '')
      return setStaticValue(false)

    if (typeof value === 'string' && !/^{(\w+)}$/.test(value))
      return setStaticValue(true)
  }

  useEffect(() => { loadValue(value) }, [value])

  if (staticValue)
    return <MergetagInputTip id={`pvalue-${index}`}>
      <Inputy {...{ value, name }}
        onChange={e => onChange && onChange(e.target.value)}
        placeholder='type a static value or create a mergetag'
        className='w-full'
      />
    </MergetagInputTip>

  return <SelectCreatable {...{ value, name, ...selectProps }}
    handleOnChange={option => {
      if (option === STATIC_OPTION)
        return setStaticValue(true)
      onChange && option && onChange(option.value)
    }}
  />
}

export const STATIC_OPTION = { value: '$$static$$', label: <strong>Static (free editing)</strong> }